import apiBase from "./api.base";

const apiClient = apiBase;

// Adicione aqui interceptors client-side se necessário
// (ex: redirect on 401, refresh token, etc.)

export default apiClient;
